import styled from 'styled-components';
import { white } from '../../style/colors';

export const Container = styled.div`
  padding: 40px;
  max-width: 1400px;
  margin: 0 auto;
`;

export const EmptyCard = styled.div`
  background: ${white};
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
`;
